import clsx from "clsx";
import makeStyles from "@mui/styles/makeStyles";

import { palette } from "../../theme/palette";
import { View } from "../View";

const useStyles = makeStyles({
  container: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    marginTop: "-0.8rem",
    marginLeft: "0.2rem",
  },
  inline: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: "4px",
  },
  roadSpeedDescription: {
    width: "6rem",
    textAlign: "right",
  },
  roadSpeedValue: {
    marginRight: "1.5rem",
  },
  text: {
    fontSize: "12px",
    color: palette.typography.white.high,
    lineHeight: "16px",
  },
  space: {
    width: "0.2rem",
  },
  flexSpace: {
    flex: 1,
  },
});
export const RoadSpeedRow = ({ roadSpeed }) => {
  const styles = useStyles();
  const { description, urban, rural } = roadSpeed;

  return (
    <View className={clsx(styles.text, styles.inline)}>
      <View className={styles.roadSpeedDescription}>{`${description}:`}</View>
      <View className={styles.roadSpeedValue}>{urban}</View>
      <View className={styles.roadSpeedValue}>{rural}</View>
    </View>
  );
};

export const RouteCardContent = ({ route }) => {
  const styles = useStyles();

  return (
    <View className={styles.container}>
      {Object.values(route.roadSpeeds).map((roadSpeed) => (
        <View key={roadSpeed.roadCode}>
          <RoadSpeedRow roadSpeed={roadSpeed} />
        </View>
      ))}
    </View>
  );
};
